import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Title from 'components/Title';

import styles from './styles.module.scss';

const Section = ({
	TitleTag,
	children,
	title,
	moreControl,
	headHide,
	renderControls,
	markupBlocks
}) => {
	const sectionHeadCx = cx(styles.head, styles[`hide_${headHide}`]);

	return (
		<div {...markupBlocks.section}>
			<div className={sectionHeadCx}>
				{title && (
					<div className={styles.heading}>
						<div className={styles.block}>
							<Title text={title} Tag={TitleTag} />
						</div>
						{moreControl && (
							<div className={styles.block} {...markupBlocks.moreButton}>
								<Title
									text={moreControl.title}
									url={moreControl.url}
									as={moreControl.as}
									theme="more"
								/>
							</div>
						)}
					</div>
				)}
				{renderControls && (
					<div className={styles.controls}>{renderControls()}</div>
				)}
			</div>
			<div className={styles.body}>{children}</div>
		</div>
	);
};

Section.propTypes = {
	TitleTag: PropTypes.oneOf(['span', 'h1', 'h2']),
	children: PropTypes.node.isRequired,
	title: PropTypes.string,
	moreControl: PropTypes.shape({
		title: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		as: PropTypes.string
	}),
	headHide: PropTypes.oneOf(['tabletLarge']),
	renderControls: PropTypes.func,
	markupBlocks: PropTypes.object
};

Section.defaultProps = {
	TitleTag: 'h2',
	markupBlocks: {}
};

export default Section;
